export default {"src":"/_next/static/media/coffee.e693f1d3.svg","height":96,"width":97};